import { useQuery } from 'react-query';

import { getCourseRates } from './index';
import { queryOptions } from '../constants';

import type { IRate } from './types';
import type { AxiosError } from 'axios';
import type { UseQueryOptions, UseQueryResult } from 'react-query';

export function useCourseRates(
  courseId?: string,
  options?: UseQueryOptions<IRate[], AxiosError, IRate[]>
): UseQueryResult<IRate[]> {
  return useQuery({
    queryKey: ['getCourseRates', courseId],
    queryFn: () => courseId ? getCourseRates(courseId) : Promise.reject('Cannot get courseId'),
    enabled: Boolean(courseId),
    initialData: [] as IRate[],
    cacheTime: 1000 * 60,
    ...queryOptions,
    ...options
  })
}
